import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<h1 class=\"ml-6 py-3 bg-opacity-30 mb-6 font-bold w-32 rounded text-2xl\">Home</h1><div class=\"px-6\"><div class=\"bg-Third p-2 rounded rounded-sm text-left mb-2 flex items-center\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"30\" height=\"30\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-info\"><circle cx=\"12\" cy=\"12\" r=\"10\"></circle><line x1=\"12\" y1=\"16\" x2=\"12\" y2=\"12\"></line><line x1=\"12\" y1=\"8\" x2=\"12.01\" y2=\"8\"></line></svg><p class=\"ml-4 text-xl\"> Purchased? Join the solarus.club discord to get the necessary resources to run the script. Join <span class=\"text-Secondary\"><a href=\"https://discord.gg/7kssH37jEc\">here</a></span>. </p></div></div>", 2)
const _hoisted_3 = { class: "px-6 mt-4 w-full h-12" }
const _hoisted_4 = {
  key: 0,
  class: "pl-6 pt-6 rounded-xl relative"
}
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<svg class=\"w-12 h-12 animate-spin text-Secondary\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 4.75V6.25\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M17.1266 6.87347L16.0659 7.93413\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M19.25 12L17.75 12\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M17.1266 17.1265L16.0659 16.0659\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M12 17.75V19.25\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M7.9342 16.0659L6.87354 17.1265\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M6.25 12L4.75 12\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M7.9342 7.93413L6.87354 6.87347\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg>", 1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 p-4 gap-4 pl-6"
}
const _hoisted_8 = { class: "bg-Third shadow-lg rounded-md flex items-center justify-between p-3 border-b-4 border-gray-600 text-white group" }
const _hoisted_9 = { class: "flex flex-row w-full" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Subscription", -1)
const _hoisted_11 = { class: "bg-Third shadow-lg rounded-md flex items-center justify-between p-3 border-b-4 border-gray-600 text-white group" }
const _hoisted_12 = { class: "flex flex-row w-full" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Member Since", -1)
const _hoisted_14 = { class: "ml-auto" }
const _hoisted_15 = { class: "bg-Third shadow-lg rounded-md flex items-center justify-between p-3 border-b-4 border-gray-600 text-white group" }
const _hoisted_16 = { class: "flex flex-row w-full" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Solarus UID", -1)
const _hoisted_18 = { class: "ml-auto" }
const _hoisted_19 = { class: "bg-Third shadow-lg rounded-md flex items-center justify-between p-3 border-b-4 border-gray-600 text-white group" }
const _hoisted_20 = { class: "flex flex-row w-full" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Username", -1)
const _hoisted_22 = { class: "ml-auto" }
const _hoisted_23 = { class: "bg-Third shadow-lg rounded-md flex items-center justify-between p-3 border-b-4 border-gray-600 text-white group" }
const _hoisted_24 = { class: "flex flex-row w-full" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Email", -1)
const _hoisted_26 = { class: "ml-auto" }
const _hoisted_27 = { class: "bg-Third shadow-lg rounded-md flex items-center justify-between p-3 border-b-4 border-gray-600 text-white group" }
const _hoisted_28 = { class: "flex flex-row w-full" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Discord", -1)
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "ml-3" }
const _hoisted_32 = {
  key: 1,
  href: "https://discord.com/api/oauth2/authorize?client_id=925106226549915658&redirect_uri=https://solarus.club/dashboard&response_type=code&scope=identify",
  class: "ml-auto text-Secondary cursor-pointer"
}
const _hoisted_33 = { class: "bg-Third shadow-lg rounded-md flex items-center justify-between p-3 border-b-4 border-gray-600 text-white group" }
const _hoisted_34 = { class: "flex flex-row w-full" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Onetap UID", -1)
const _hoisted_36 = { class: "ml-auto" }
const _hoisted_37 = { class: "bg-Third shadow-lg rounded-md flex items-center justify-between p-3 border-b-4 border-gray-600 text-white group" }
const _hoisted_38 = { class: "flex flex-row w-full" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Onetap Username", -1)
const _hoisted_40 = { class: "ml-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navigate && _ctx.navigate(...args))),
        class: "bg-Secondary w-full h-full rounded rounded-sm text-center"
      }, " Purchase Subscription ")
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
      : _createCommentVNode("", true),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("p", {
                class: _normalizeClass([{ 'text-red-300': _ctx.subscription_value === 'Not subscribed' }, "ml-auto text-sm"])
              }, _toDisplayString(_ctx.subscription_value), 3)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.created_at), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.solarus_uid), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.username), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.email), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              (_ctx.discord_linked)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: 'https://cdn.discordapp.com/avatars/' + _ctx.discord_id + '/' + _ctx.discord_avatarid,
                    class: "w-6 h-6 rounded-full ml-auto",
                    alt: "discord"
                  }, null, 8, _hoisted_30))
                : _createCommentVNode("", true),
              _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.discord_username), 1),
              (!_ctx.discord_linked)
                ? (_openBlock(), _createElementBlock("a", _hoisted_32, "Link"))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.onetap_uid), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.onetap_username), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}